/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@packages/api-client/client-config";
import type { GetLivestockAnimalWeightHistoryQueryResponse, GetLivestockAnimalWeightHistoryPathParams, GetLivestockAnimalWeightHistory400, GetLivestockAnimalWeightHistory401, GetLivestockAnimalWeightHistory403, GetLivestockAnimalWeightHistory404, GetLivestockAnimalWeightHistory409, GetLivestockAnimalWeightHistory500 } from "../../types/livestockController/GetLivestockAnimalWeightHistory.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";

function getGetLivestockAnimalWeightHistoryUrl(organizationId: GetLivestockAnimalWeightHistoryPathParams["organizationId"], animalId: GetLivestockAnimalWeightHistoryPathParams["animalId"]) {
  const res = { method: 'GET', url: `/api/organizations/${organizationId}/livestock/animals/${animalId}/weight-history` as const }
  return res
}

/**
 * @summary Weight history for an animal: every weighing, GMD windows (incl. lifetime), arroba/carcass estimate, herd-target projection, lot rank and weaning
 * {@link /api/organizations/:organizationId/livestock/animals/:animalId/weight-history}
 */
export async function getLivestockAnimalWeightHistory(organizationId: GetLivestockAnimalWeightHistoryPathParams["organizationId"], animalId: GetLivestockAnimalWeightHistoryPathParams["animalId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetLivestockAnimalWeightHistoryQueryResponse, ResponseErrorConfig<GetLivestockAnimalWeightHistory400 | GetLivestockAnimalWeightHistory401 | GetLivestockAnimalWeightHistory403 | GetLivestockAnimalWeightHistory404 | GetLivestockAnimalWeightHistory409 | GetLivestockAnimalWeightHistory500>, unknown>({ method : "GET", url : getGetLivestockAnimalWeightHistoryUrl(organizationId, animalId).url.toString(), ... requestConfig })
  return res.data
}